import { NOTIFICATION_TYPES }     from '../types';
import BiometriaNotification  from '../components/BiometriaNotification';
import SolicitudNotification  from '../components/SolicitudNotification';

const BIOMETRIA_ESTADOS = {
  0: { label: 'No aplica firma digital',   type: 'info'    },
  1: { label: 'Aplica firma digital',      type: 'info'    },
  2: { label: 'Link biométrico enviado',   type: 'warning' },
  3: { label: 'Aceptado',                  type: 'success' },
  4: { label: 'Prueba de vida procesando', type: 'warning' },
  5: { label: 'Prueba de vida en curso',   type: 'warning' },
  6: { label: 'Proceso completado',        type: 'success' },
  7: { label: 'Verificación rechazada',    type: 'error'   },
};

/**
 * Registro central de notificaciones.
 *
 * Para agregar un nuevo tipo de notificación:
 *   1. Añadir la constante en types.js
 *   2. Crear el componente en notifications/components/
 *   3. Registrarlo aquí — sin modificar ningún otro archivo.
 */
export const notificationRegistry = {
  [NOTIFICATION_TYPES.BIOMETRIA_EVENTO]: {
    component: BiometriaNotification,
    duration:  7000,
    priority:  2,
    transform(payload) {
      const { idEstado, numeroSolicitud, cliente, sCre_SolicitudWeb } = payload;
      const estado = BIOMETRIA_ESTADOS[idEstado]
        ?? { label: `Estado ${idEstado}`, type: 'info' };
      return {
        message:  `Firma Biométrica: ${estado.label.toUpperCase()}`,
        subtitle: `${cliente ?? 'Cliente'} — Sol. ${numeroSolicitud ?? sCre_SolicitudWeb ?? ''}`,
        type:     estado.type,
        raw:      payload,
      };
    },
  },

  [NOTIFICATION_TYPES.SOLICITUD_CHANGED]: {
    component: SolicitudNotification,
    duration:  4000,
    priority:  1,
    silent:    true, // socket activo, sin notificación visual
    transform(payload) {
      return {
        message:  'Solicitud actualizada',
        subtitle: payload?.id ? `Solicitud #${payload.id}` : '',
        type:     'info',
        raw:      payload,
      };
    },
  },
};
